import styled from 'styled-components/macro'

const FieldListHeader = styled.header`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid;
  margin-bottom: .5em;
  > * {
    flex: 1;
    margin: 0 0.5em;
  }
`

export default FieldListHeader
